module.exports = __webpack_public_path__ + "img/hello-animated.6c74af7.webp?v=1764903765445";